/* =============================================================================
=   Query Vehicle Models
============================================================================= */
import { gql } from '@apollo/client';

export default gql`
  query vehicleModelDetails($modelId: Int!) {
    vehicleModelDetails(modelId: $modelId) {
      id
      fullModelCode
      brand
      year
      region
      name
      model
      edition
      assetPath
      active
      vehicleMarketStatusDesc
      basePrice
      depositAmount
      preorderDepositAmount
      reserveSpotCap
      isWaitlistAllowed
      vehicleOverviewAssets {
        version
        locale
        id
        title
        model
        edition
        expectAvailableDate
        overviewFeatures {
          title
          description
        }
        overviewSpecs {
          title
          description
        }
      }
      vehicleConfigurationAssets {
        version
        locale
        title
        expectAvailableDate
        exterior {
          color {
            categoryCode
            categoryName
            typeCodes
            typeValues {
              code
              title
              tileImage
              images
              images2 {
                mobile
                tablet
                desktop
              }
              specs {
                title
                description
              }
            }
            configuredOption {
              code
              title
              tileImage
              images
            }
          }
        }
        wheel {
          categoryCode
          categoryName
          typeCodes
          typeValues {
            code
            title
            tileImage
            images
            specs {
              title
              description
            }
            imageSets {
              categoryCode
              code
              images
              images2 {
                mobile
                tablet
                desktop 
              }
            }
            exteriorImages {
              categoryCode
              code
              images
              images2 {
                mobile
                tablet
                desktop
              }
            }
          }
          configuredOption {
            code
            title
            tileImage
            images
          }
        }
        interior {
          color {
            categoryCode
            categoryName
            typeCodes
            typeValues {
              code
              title
              tileImage
              images
              images2 {
                mobile
                tablet
                desktop
              }
              specs {
                title
                description
              }
            }
            configuredOption {
              code
              title
              tileImage
              images
            }
            features {
              title
            }
          }
        }
      }
    }
  }
`;
